// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"FL-z","carouselContainer":"GL-z"};